<template>
  <v-dialog  v-model="tourdialog" transition="dialog-top-transition" max-width="1000" class="d-print-none" @click:outside="closeDialog">
    <v-card  id="tour" width="100%" min-height="640" color="white" class="px-8 py-4 d-flex flex-column"  > 
      <v-card-title class="pa-0 mb-md-4">
        <h2 class="text-h2 mt-2">{{$t('tour.title')}}</h2>
        <v-spacer></v-spacer>
        <v-btn small icon @click="closeDialog"><v-icon color="darkgrey">mdi-close</v-icon></v-btn> 
      </v-card-title>

      <v-stepper v-model="page" alt-labels non-linear >

        <v-stepper-header flat dense class="hidden-sm-and-down">
          <v-stepper-step  step="1" editable edit-icon="mdi-check" color="liiblack"  @click.native="visited.push(1)" :complete="visited.includes(1)" >{{$t('tour.step1')}}</v-stepper-step>
          <v-stepper-step step="2" editable edit-icon="mdi-check" color="liiblack"  @click.native="visited.push(2)"  :complete="visited.includes(2)">{{$t('tour.step2')}}</v-stepper-step>
          <v-stepper-step step="3" editable edit-icon="mdi-check" color="liiblack" @click.native="visited.push(3)"  :complete="visited.includes(3)">{{$t('tour.step3')}}</v-stepper-step>
          <v-stepper-step step="4" editable edit-icon="mdi-check" color="liiblack"  @click.native="visited.push(4)"  :complete="visited.includes(4)">{{$t('tour.step4')}}</v-stepper-step>
          <v-stepper-step step="5" editable edit-icon="mdi-check" color="liiblack"  @click.native="visited.push(5)"  :complete="visited.includes(5)">{{$t('tour.step5')}}</v-stepper-step>
        </v-stepper-header>

        <v-divider class="mt-3 hidden-sm-and-down"></v-divider>

        <!--content--->
        <v-stepper-items>
          <v-stepper-content step="1" class="px-0 py-3">
            <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title1')}}</h4>
            <v-row no-gutters class="lsidebg">
              <v-col cols="12" md="8" class="pa-0"> 
                <!-- Using image, not working for some devices
                <v-img contain class="pr-2" position="left top "
                :src="require('../assets/t_layout.gif')"  alt="layout showcase and scrolling demo"
                max-height="400" />-->
                <video autoplay loop muted playsinline>
                  <source src="../assets/t_layout.webm"  type="video/webm" >
                  <source src="../assets/t_layout.mp4"  type="video/mp4" >
                  {{$t('tour.videoerror')}}
                </video>
              </v-col>
              <v-col cols="12" md="4"  class="tour-body pa-4 mt-md-0 mt-4"> 
                <div>
                  <p
                    v-for="(para, idx) in $i18n.t('tour.desc1')"
                    :key="'desc1_' + idx"
                    v-html="para"
                  ></p>
                </div>
              </v-col>
            </v-row>  
          </v-stepper-content>

            <v-stepper-content step="2" class="px-0 py-3">
                <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title2')}}</h4>
                <v-row no-gutters class="lsidebg">
                  <v-col cols="12" md="8" class="pa-0"> 
                    <video autoplay loop muted playsinline>
                      <source src="../assets/t_searchdemo.webm"  type="video/webm" >
                      <source src="../assets/t_searchdemo.mp4"  type="video/mp4" >
                      {{$t('tour.videoerror')}}
                    </video>
                  </v-col>
                  <v-col cols="12" md="4"  class="tour-body pa-4 mt-md-0 mt-4"> 
                    <div>
                      <i18n path="tour.desc2[0]" tag="p">
                        <b>{{$t('tour.any_content')}}</b>
                        <router-link :to="{name: 'operators'}">{{$t('tour.operators')}}</router-link>
                      </i18n>
                      <p>{{$t('tour.desc2[1]')}}</p>
                    </div>
                  </v-col>
                </v-row>
            </v-stepper-content>

            <v-stepper-content step="3" class="px-0 py-3">
                <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title3')}}</h4>
                <v-row no-gutters class="lsidebg">
                    <v-col  cols="12" md="8"> 
                      <video autoplay loop muted playsinline>
                        <source src="../assets/t_advdemo.webm"  type="video/webm" >
                        <source src="../assets/t_advdemo.mp4"  type="video/mp4" >
                        {{$t('tour.videoerror')}}
                    </video>
                    </v-col>
                    <v-col  cols="12" md="4"  class="tour-body pa-4 mt-md-0 mt-4"> 
                      <div>
                        <p
                          v-for="(para, idx) in $i18n.t('tour.desc3')"
                          :key="'desc3_' + idx"
                          v-html="para"
                        ></p>
                      </div>
                    </v-col>
                </v-row>   
            </v-stepper-content>

            <v-stepper-content step="4" class="px-0 py-3">
              <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title4')}}</h4>
              <v-row no-gutters class="lsidebg">
                <v-col  cols="12" md="8"  > 
                  <video autoplay loop muted playsinline>
                    <source src="../assets/t_noteup.webm"  type="video/webm" >
                    <source src="../assets/t_noteup.mp4"  type="video/mp4" >
                    {{$t('tour.videoerror')}}
                  </video>
                </v-col>
                <v-col  cols="12" md="4"  class=" tour-body pa-4 mt-md-0 mt-4"> 
                  <div>
                    <p
                      v-for="(para, idx) in $i18n.t('tour.desc4')"
                      :key="'desc4_' + idx"
                      v-html="para"
                    ></p>
                  </div>
                </v-col>
              </v-row>             
            </v-stepper-content>

            <v-stepper-content step="5" class="px-0 py-3">
              <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title5')}}</h4>      
              <v-row no-gutters class="lsidebg">
                <v-col cols="12" md="8"> 
                  <video autoplay loop muted playsinline>
                    <source src="../assets/t_legis.webm"  type="video/webm" >
                    <source src="../assets/t_legis.mp4"  type="video/mp4" >
                    {{$t('tour.videoerror')}}
                  </video>
                  </v-col>
                  <v-col cols="12" md="4" class="tour-body pa-4 mt-md-0 mt-4"> 
                    <div>
                      <p
                        v-for="(para, idx) in $i18n.t('tour.desc5')"
                        :key="'desc5_' + idx"
                        v-html="para"
                      ></p>
                    </div>
                  </v-col>
              </v-row>
            </v-stepper-content>
            
            <v-stepper-content step="6" class="px-0 py-3">
              <h4 class="text-h4 mt-2 mb-4 font-italic liiblack--text">{{$t('tour.title6')}}</h4>
              <v-row no-gutters>
                  <v-col cols="12" md="4" :align="$vuetify.breakpoint.mdAndUp?'right':'center'"> 
                      <v-img contain class="pr-2" position="left top "
                      :src="require('../assets/t_highfive.png')"  alt="High-five!"
                      max-width="250"  max-height="300" />
                  </v-col>
                  <v-col cols="12" md="8" class="tour-body pa-4 pl-md-6 pr-md-10 mt-md-0 mt-4"> 
                    <div>
                      <i18n path="tour.desc6[0]" tag="p">
                        <template v-slot:email>
                          <router-link :to="{name: 'feedback'}">{{$t('tour.email')}}</router-link>
                        </template>
                        <template v-slot:rating>
                          <a @click="openRateDialog">{{$t('tour.rating')}}</a>
                        </template>
                      </i18n>
                      <i18n path="tour.desc6[1]" tag="p">
                        <template v-slot:email>
                          <router-link :to="{name: 'feedback'}">{{$t('tour.email')}}</router-link>
                        </template>
                        <template v-slot:rating>
                          <a @click="openRateDialog">{{$t('tour.rating')}}</a>
                        </template>
                      </i18n>
                    </div>
                  </v-col>
              </v-row>
            </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
            
      <!--bottom nav buttons-->
      <v-row no-gutters class="mb-3 mt-auto  align-end" > 
        <v-btn color="liiblack" large class="white--text" @click="page--" v-show="page>1"> 
          <v-icon small class="mr-4">mdi-arrow-left</v-icon>  {{$t('btntxt.prev')}} 
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="liiblack" large class="white--text" @click="NextPage" v-show="page<6"> 
          {{$t('btntxt.next')}} <v-icon small class="ml-4">mdi-arrow-right</v-icon> 
        </v-btn>
        <v-btn text color="liiblack" large class="white--text" @click="closeDialog" v-show="page==6"> 
          {{$t('btntxt.close')}} <v-icon small class="ml-4">mdi-close</v-icon> 
        </v-btn>
      </v-row>

    </v-card>
  </v-dialog>
</template>


<script>
  export default {
    name: 'Tour',
    props:{   
      tourdialog: {type: Boolean},
    },
    data(){
      return{
        page: 1,
        visited: [1],
      }
    },
    methods: {
      PrevPage(){
        this.page--
      },
      NextPage(){
        this.page++
        this.visited.push(this.page)
      },
      closeDialog(){
        this.$emit('close-dialog')
      },
      openRateDialog(){
        this.$emit('close-dialog')
        this.$emit('open-rate-dialog')
      }
    },
    updated() {
      document.getElementsByTagName("video").forEach(v => v.playbackRate="0.7")
      document.getElementsByTagName("video").forEach(v => v.defaultPlaybackRate="0.7")
    }
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  .tour-body {
    max-width: 800px;  
  }

  a {
    @include link-underlined;
  }

  p {  
    margin-bottom: 12px;
    font-size: 0.96em;
    line-height: 1.3em;
  }

  .hide {
    display: none;
  }
</style>